/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Notification Disconnect (Session Timeout)
 * Icon component.
 *
 * ! NOTE: This Icon defines non-standard sizes within the DLS
 */
export const NotificationDisconnectIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox={`0 0 ${iconSize} ${iconSize}`} fill='none'>
      <path d='M19.721 6.04A7.49 7.49 0 0012.371 0c-1.48 0-2.85.43-4.01 1.17l1.46 1.46a5.497 5.497 0 018.05 4.87V8h1.5c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45c1.27-.91 2.11-2.39 2.11-4.07 0-2.64-2.05-4.78-4.65-4.96zM3.371 1.27l2.75 2.74C2.931 4.15.371 6.77.371 10c0 3.31 2.69 6 6 6h11.73l2 2 1.27-1.27L4.641 0l-1.27 1.27zM8.101 6l8 8h-9.73c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z'
        fill={iconColor} />
    </svg>
  );
};
